<template>
  <div class="ficha-panel">
    <!-- Loader durante validación/carga -->
    <div v-if="cargandoFicha" class="text-center py-5">
      <i class="fas fa-spinner fa-spin mr-2"></i>
      <small>{{ $t('ficha_validando') }}</small>
    </div>

    <!-- Solo lectura sin ficha creada: no se ofrece la creación -->
    <div v-else-if="esSoloLectura && !fichaCargada" class="text-center py-5 text-muted">
      <i class="fas fa-file-alt fa-2x mb-3 d-block"></i>
      <p class="mb-0">{{ $t('ficha_sin_ficha_solo_lectura') }}</p>
    </div>

    <!-- Vista de selección de tipo de ficha -->
    <div v-else-if="!fichaSeleccionada" class="selector-view">
      <!-- Título -->
      <div class="panel-header mb-4">
        <h4 class="text-primary mb-3">{{ $t('ficha_seleccionar_tipo') }}</h4>
        <!-- 🆕 Mostrar ID del cluster si existe -->
        <div v-if="clusterId" class="cluster-info">
          <small class="text-muted">
            <i class="fas fa-info-circle mr-1"></i>
            {{ $t('ficha_creando_cluster') }}: <strong>{{ clusterId }}</strong><span v-if="idDetalle"> — {{ $t('ficha_detalle') }}: <strong>{{ idDetalle }}</strong></span>
          </small>
        </div>
      </div>
      
      <!-- Botones de selección -->
      <div class="ficha-buttons-container">
        <div class="row">
          <div class="col-md-6 col-lg-6 mb-3">
            <button 
              class="btn btn-ficha w-100" 
              @click="seleccionarFicha('equipos')"
            >
              <i class="fas fa-cogs mb-2"></i>
              <div>{{ $t('ficha_equipos') }}</div>
            </button>
          </div>

          <div class="col-md-6 col-lg-6 mb-3">
            <button 
              class="btn btn-ficha w-100" 
              @click="seleccionarFicha('correas')"
            >
              <i class="fas fa-link mb-2"></i>
              <div>{{ $t('ficha_correas') }}</div>
            </button>
          </div>

          <div class="col-md-6 col-lg-6 mb-3">
            <button
              class="btn btn-ficha w-100"
              @click="seleccionarFicha('neumaticos')"
            >
              <i class="fas fa-circle mb-2"></i>
              <div>{{ $t('ficha_neumaticos') }}</div>
            </button>
          </div>

          <div class="col-md-6 col-lg-6 mb-3">
            <button
              class="btn btn-ficha w-100"
              @click="seleccionarFicha('componentes')"
            >
              <i class="fas fa-puzzle-piece mb-2"></i>
              <div>{{ $t('ficha_componentes') }}</div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Vista del formulario seleccionado -->
    <div v-else class="formulario-view">
      <!-- Header con botón volver y título -->
      <div class="formulario-header d-flex align-items-center justify-content-between mb-4">
        <div class="d-flex align-items-center">
          <!-- <button 
            class="btn btn-outline-secondary btn-sm me-3" 
            @click="volverASelector"
          >
            <i class="fas fa-arrow-left me-1"></i>
            Volver
          </button> -->
          <h4 class="mb-0 text-primary">{{ tituloFormulario }}</h4>
        </div>
        <div v-if="clusterId" class="cluster-badge">
          <span class="badge badge-secondary">Cluster: {{ clusterId }}<span v-if="idDetalle"> — {{ $t('ficha_detalle') }}: {{ idDetalle }}</span></span>
        </div>
      </div>

      <!-- Contenido del formulario -->
      <div class="formulario-content">
        <div v-if="fichaSeleccionada === 'equipos'">
          <FichaVentaEquipos ref="fichaForm" :cluster="cluster" :token="token" :ficha="fichaCargada" :idTipoFicha="1" :idCluster="clusterId" :idDetalle="idDetalle" :idCriterio="criterioId" :mostrarMultimedia="mostrarMultimedia" @guardado="$emit('guardado', $event)" @abrir-multimedia="$emit('abrir-multimedia', $event)"/>
        </div>

        <div v-if="fichaSeleccionada === 'correas'" class="formulario-placeholder">
          <FichaVentaEquipos ref="fichaForm" :cluster="cluster" :token="token" :ficha="fichaCargada" :idTipoFicha="3" :idCluster="clusterId" :idDetalle="idDetalle" :idCriterio="criterioId" :mostrarMultimedia="mostrarMultimedia" @guardado="$emit('guardado', $event)" @abrir-multimedia="$emit('abrir-multimedia', $event)"/>
        </div>

        <div v-if="fichaSeleccionada === 'neumaticos'" class="formulario-placeholder">
          <FichaVentaEquipos ref="fichaForm" :cluster="cluster" :token="token" :ficha="fichaCargada" :idTipoFicha="4" :idCluster="clusterId" :idDetalle="idDetalle" :idCriterio="criterioId" :mostrarMultimedia="mostrarMultimedia" @guardado="$emit('guardado', $event)" @abrir-multimedia="$emit('abrir-multimedia', $event)"/>
        </div>

        <div v-if="fichaSeleccionada === 'componentes'" class="formulario-placeholder">
          <FichaVentaEquipos ref="fichaForm" :cluster="cluster" :token="token" :ficha="fichaCargada" :idTipoFicha="2" :idCluster="clusterId" :idDetalle="idDetalle" :idCriterio="criterioId" :mostrarMultimedia="mostrarMultimedia" @guardado="$emit('guardado', $event)" @abrir-multimedia="$emit('abrir-multimedia', $event)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FichaVentaEquipos from './Formularios/FichaVentaEquipos.vue'
import fichaService from '@/api/fichaService.vue'

export default {
  name: 'FichaPanel',
  props: {
    cluster:    { type: [Object], default: null },
    token:      { type: String, required: true },
    idCluster:  { type: [Number, String], default: null },
    idDetalle:  { type: [Number, String], default: null },
    idCriterio: { type: [Number, String], default: null },
    /** Se propaga tal cual a la ficha: la columna Multimedia de la sección 2. */
    mostrarMultimedia: { type: Boolean, default: false }
  },
  components: { FichaVentaEquipos },
  data() {
    return {
      fichaSeleccionada: null,
      fichaCargada: null,
      cargandoFicha: true
    }
  },
  computed: {
    clusterId() {
      if (this.idCluster != null) return this.idCluster;
      const c = this.cluster;
      if (!c) return null;
      return c.numeroCluster || c.id || null;
    },
    criterioId() {
      if (this.idCriterio != null) return this.idCriterio;
      const c = this.cluster;
      return c ? c.idCriterio || null : null;
    },
    tituloFormulario() {
      return this.$t('formulario_venta_titulo');
    }
  },
  mounted() {
    this.abrirFichaExistenteSiAplica();
  },
  watch: {
    cluster: {
      deep: true,
      handler() { this.abrirFichaExistenteSiAplica(); }
    }
  },
  methods: {
    limpiar() {
      if (this.$refs.fichaForm) this.$refs.fichaForm.resetForm()
    },
    verFicha() {
      if (this.$refs.fichaForm) this.$refs.fichaForm.verFichaPdf()
    },
    guardar() {
      if (!this.puedeEscribir) return;
      if (this.$refs.fichaForm) this.$refs.fichaForm.submitForm()
    },

    // Agrego método para seleccionar ficha manualmente
    seleccionarFicha(tipo) {
      this.fichaSeleccionada = tipo;
      console.log(`📋 Ficha ${tipo} seleccionada para cluster:`, this.clusterId);
    },
    
    // Agrego método para volver al selector
    volverASelector() {
      // Si hay ficha cargada, permanecer en el formulario correspondiente
      if (this.fichaCargada && this.fichaCargada.idTipoFicha) {
        this.fichaSeleccionada = this.mapTipoFicha(this.fichaCargada.idTipoFicha);
        return;
      }
      this.fichaSeleccionada = null;
    },

    mapTipoFicha(idTipoFicha) {
      switch (idTipoFicha) {
        case 1: return 'equipos';
        case 2: return 'componentes';
        case 3: return 'correas';
        case 4: return 'neumaticos';
        default: return null;
      }
    },
    
    async abrirFichaExistenteSiAplica() {
      const c = this.cluster;
      this.cargandoFicha = true;
      await new Promise(res => setTimeout(res, 250));
      
      if (!c) { 
        this.cargandoFicha = false; 
        return; 
      }

      if (c.idFicha) {
        try {
          const ficha = await fichaService.obtenerPorId(c.idFicha);
          this.fichaCargada = ficha || null;
          const tipo = ficha && ficha.idTipoFicha ? this.mapTipoFicha(ficha.idTipoFicha) : null;
          const fallbackTipo = !tipo && c.idTipoFicha ? this.mapTipoFicha(c.idTipoFicha) : null;

          console.log('📋 Ficha existente idTipoFichamap:', ficha.idTipoFicha);
          console.log('📋 Ficha existente map:', this.mapTipoFicha(ficha.idTipoFicha));
          console.log('📋 Ficha existente cargada tipo:', tipo); 
          this.fichaSeleccionada = tipo || fallbackTipo || 'equipos';
        } catch (e) {
          console.error('Error obteniendo ficha existente:', e);
          this.fichaSeleccionada = c.idTipoFicha ? this.mapTipoFicha(c.idTipoFicha) : 'equipos';
        } finally {
          this.cargandoFicha = false;
        }
        return;
      }

      // Sin idFicha: abrir por idTipoFicha del cluster si existe, de lo contrario usar tipo 1 (equipos)
      const fallbackTipo = c.idTipoFicha ? this.mapTipoFicha(c.idTipoFicha) : null;
      this.fichaSeleccionada = fallbackTipo || 'equipos';
      this.cargandoFicha = false;
    }
  }
}
</script>

<style scoped>
.ficha-panel {
  min-height: 400px;
}

.selector-view {
  padding: 20px;
}

.formulario-view {
  padding: 20px;
  height: 100%;
}

.panel-header h4 {
  font-weight: 600;
  color: #2d3e5f;
}

.ficha-buttons-container {
  margin-bottom: 20px;
}

.btn-ficha {
  height: 120px;
  border: 2px solid #e9ecef;
  background: #ffffff;
  color: #6c757d;
  border-radius: 12px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}

.btn-ficha:hover {
  border-color: #6172e9;
  color: #6172e9;
  background: #f8f9ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(97, 114, 233, 0.15);
}

.btn-ficha i {
  font-size: 24px;
  display: block;
}

.formulario-header {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.formulario-header h4 {
  font-weight: 600;
  color: #2d3e5f;
}

.formulario-content {
  flex: 1;
  min-height: 300px;
}

.formulario-placeholder {
  padding: 60px 20px;
  text-align: center;
  background: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #e9ecef;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.formulario-placeholder p {
  margin-bottom: 10px;
}

/* 🆕 Estilos para info del cluster */
.cluster-info {
  padding: 8px 12px;
  background: #f8f9ff;
  border-radius: 6px;
  margin-top: 10px;
  border-left: 3px solid #6172e9;
}

.cluster-badge {
  display: flex;
  align-items: center;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

/* Botón volver */
.btn-outline-secondary {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #ffffff;
}

@media (max-width: 768px) {
  .btn-ficha {
    height: 100px;
    font-size: 13px;
  }
  
  .btn-ficha i {
    font-size: 20px;
  }

  .formulario-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .formulario-header .d-flex:first-child {
    width: 100%;
    margin-bottom: 10px;
  }

  .formulario-header h4 {
    font-size: 1.1rem;
  }

  .cluster-badge {
    margin-top: 10px;
  }
}
</style>
